module.exports = __webpack_public_path__ + "static/media/logo-segmedic.30c6035b.svg";